import { FikoYTEnvIstemci } from '@/src/service/Environment/environment';
import { CommonModule, DOCUMENT, NgOptimizedImage } from '@angular/common';
import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentRef, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

import { FormsModule } from '@angular/forms';
import { IKart, IIcerik, IEkTuru, IYuzEtiketi } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';

import { FikoSesOynaticiComponent } from '../../../fiko-ses-oynatici/fiko-ses-oynatici.component';
import { PaylasTextEditorComponent } from '../../paylas-kutusu/IKart/paylas-text-editor/paylas-text-editor.component';
import { IKartComponent } from '../../paylas-kutusu/IKart/ikart-kutusu.component';
import { FikoYTService } from '@/src/service/fikoyt.service';
import { SoyAgaciService } from '@/src/app/uygulamalar/soyagaci/services/soy-agaci.service';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzModalService, NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { escapeRegex } from '@/src/app/shared/utils/regex.utils';
import { IUyarKartComponent } from '../../paylas-kutusu/IKart/paylas-icerik-editor/IUyarDokum/uyar-kutusu.component';
import { YuzCropComponent } from '@/src/app/shared/components/yuz-crop/yuz-crop.component';
import { KisiBalonV2Component } from '@/src/app/shared/components/kisi-balon/kisi-balon.component';
import { ParametrelerComponent } from '../../../parametreler/parametreler.component';
import { SablonRendererComponent } from '../../sablon-renderer/sablon-renderer.component';
import { DinamikBilesenRendererComponent } from '../../../dinamik-bilesen/dinamik-bilesen-renderer.component';
import { FikoStpOnizlemeKartiComponent } from '../../../fiko-three-js/fiko-stp-onizleme-karti/fiko-stp-onizleme-karti.component';

// Yüz tanıma etiket çözümleme (lazy — modül olmayabilir)
// NOT: Race condition riski var ama yuzEtiketleriCozumle() satır 385'te
// `if (!_etiketleriCozumle) return;` guard'ı ile korunuyor, dolayısıyla güvenli.
let _etiketleriCozumle: any = null;
try {
  import('@/src/app/uygulamalar/yuz-tanima/utils/etiket-cozumle').then(m => _etiketleriCozumle = m.etiketleriCozumle).catch(() => {});
} catch {}

declare var $: any;

@Component({
  selector: 'fikoyt-icerikler',
  templateUrl: './icerikler.component.html',
  styleUrls: ['./icerikler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterModule,
    FormsModule,
    FikoSesOynaticiComponent,
    PaylasTextEditorComponent,
    IUyarKartComponent,
    NzButtonModule,
    NzInputModule,
    NzTooltipModule,
    NzTimelineModule,
    NzPopconfirmModule,
    KisiBalonV2Component,
    YuzCropComponent,
    NzPopoverModule,
    ParametrelerComponent,
    SablonRendererComponent,
    NzModalModule,
    DinamikBilesenRendererComponent,
    FikoStpOnizlemeKartiComponent,
  ],
  standalone: true,
})
export class IceriklerComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  @ViewChild('referansKonteynir', { read: ViewContainerRef, static: true }) referansKonteynir: ViewContainerRef;
  @ViewChild('konumHaritaDiv') konumHaritaDiv: ElementRef<HTMLDivElement>;
  @ViewChild('lightboxOverlay') lightboxOverlay: ElementRef<HTMLDivElement>;

  private konumLeafletMap: any = null;
  private konumHaritaAktifId: string = null;

  // Socket.IO isleniyor subscription'i — duplicate subscription onleme
  private _isleniyorSub: Subscription | null = null;

  /** */
  @Input() kart: IKart;

  public get aktifMedya(): string {
    //@ts-ignore
    return this.FikoYT.aktifMedyaid;
  }
  @Input() public set aktifMedya(v: string) {
    //@ts-ignore
    this.FikoYT.aktifMedyaid = v;
    // this.CD.detectChanges();
    // this.aktifMedyaChange.emit(v);
  }
  /** */
  subsList: Subscription[] = [];
  /** */

  /** */
  medyaAktif: boolean;
  /** 🪶 Gömülü STEP/WRL 3D önizlemesi açıkken diğer kart öğelerini gizleyip alanı ona bırakmak için */
  stp3dAktif: boolean = false;
  /** */
  get aktifIcerik() {
    // console.log(this.icerikler[this.aktifIcerikNo])
    return this.icerikler[this.aktifIcerikNo];
  }
  /** */
  private _icerikler: IIcerik[];
  public get icerikler(): IIcerik[] {
    return this._icerikler;
  }
  @Input() public set icerikler(v: IIcerik[]) {
    this._icerikler = v || [{ html: '' }];
    // this.CD.detectChanges();

    if (this.referansKonteynir) {

      if (this._icerikler?.length > 0) {

        if (this._icerikler[this.aktifIcerikNo]?.ek?.rid != null) {
          if (!(this.referansKonteynir.length > 0)) {
            // this.referansKonteynir.clear()
            let referansBilesen: ComponentRef<IKartComponent> = this.referansKonteynir.createComponent(IKartComponent, { index: 0 });
            //@ts-ignore
            referansBilesen.instance.kart = this._icerikler[this.aktifIcerikNo].ek.rid;
            // referansBilesen.instance.bilesenRefeans = referansBilesen;
            // referansBilesen.instance.miReferans = true;
          } else {
            //@ts-ignore
            this.referansKonteynir.get(0)._view[this.referansKonteynir.get(0)._view.length - 1].kart = this._icerikler[this.aktifIcerikNo].ek.rid
          }
        }

      }

    }

    if (this.icerikler?.length > 0) {
      if (this._icerikler[this.aktifIcerikNo]?.ek?.isleniyor?.evet) {
        // Onceki isleniyor subscription'ini temizle (duplicate onleme)
        this._isleniyorSub?.unsubscribe();
        this._isleniyorSub = this.FikoYT.io.fromEvent(`FikoYT.sistem.hareketler.${this._icerikler[this.aktifIcerikNo]?.ek?._id}.isleniyor`).subscribe((k: any) => {
            k.yuzde = Number((k.yuzde).toFixed(3))
            this._icerikler[this.aktifIcerikNo].ek.isleniyor = k;
            this.CD.detectChanges();
          });
      }
    }

    this.CD.detectChanges();
  }

  @Output() iceriklerChange: EventEmitter<any> = new EventEmitter();

  @Input() duzenlemeModunda: boolean = false;
  @Output() duzenlemeBaslatildi: EventEmitter<void> = new EventEmitter<void>();

  /** Kullanıcı rolleri (parametre düzenleme yetkisi için) */
  get kullaniciRolleri(): string[] {
    return this.FikoYT?.kimlik?.aktifKullaniciJson()?._uyeYetkiler ?? [];
  }

  duzenleyebilirMi(): boolean {
    const kullaniciId = this.FikoYT?.kimlik?.aktifKullaniciJson()?._id;
    if (!kullaniciId) return false;
    return this.kart?.sahip === kullaniciId || this.kullaniciRolleri.includes('Süper Yönetici');
  }

  sablonParametreDuzenle(olay: { parametreAnahtari: string; mevcutDeger: any }, icerik: any) {
    const parametre = (icerik?.ek?.parametreler ?? []).find((p: any) => p.ismi === olay.parametreAnahtari);
    if (!parametre) return;

    this._sablonDuzenleParametre = JSON.parse(JSON.stringify(icerik?.ek?.parametreler ?? []));
    this._sablonDuzenleIcerik = icerik;
    this.CD.detectChanges();
  }

  _sablonDuzenleParametre: any[] | null = null;
  _sablonDuzenleIcerik: any = null;

  sablonDuzenleKaydet() {
    if (!this._sablonDuzenleParametre?.length || !this._sablonDuzenleIcerik) return;
    // Tüm parametrelerin değerlerini orijinallere aktar
    for (const duzenlemis of this._sablonDuzenleParametre) {
      const hedef = (this._sablonDuzenleIcerik?.ek?.parametreler ?? []).find((p: any) => p.ismi === duzenlemis.ismi);
      if (hedef) hedef.degeri = duzenlemis.degeri;
    }
    this.onUygulamaParametreDegisti();
    this._sablonDuzenleParametre = null;
    this._sablonDuzenleIcerik = null;
    this.CD.detectChanges();
  }

  sablonDuzenleIptal() {
    this._sablonDuzenleParametre = null;
    this._sablonDuzenleIcerik = null;
    this.CD.detectChanges();
  }

  sablonResimDegisti(olay: { parametreAnahtari: string; dosya: File; objectUrl: string }, icerik: any) {
    const parametre = (icerik?.ek?.parametreler ?? []).find((p: any) => p.ismi === olay.parametreAnahtari);
    if (!parametre) return;
    parametre.degeri = olay.objectUrl;
    this.onUygulamaParametreDegisti();
    this.CD.detectChanges();
  }

  parametreDegerleriHesapla(icerik: any): { [key: string]: any } {
    const sonuc: any = {};
    for (const p of (icerik?.ek?.parametreler ?? [])) {
      if (p.ismi) sonuc[p.ismi] = p.degeri;
    }
    return sonuc;
  }

  /** UYGULAMAICERIK parametresi değiştiğinde DB'ye kaydet */
  onUygulamaParametreDegisti() {
    const icerik = this.aktifIcerik;
    if (!icerik?._id || !icerik?.ek?.parametreler) return;

    // Debounce ile kaydet
    clearTimeout(this._uygulamaParamKaydetTimer);
    this._uygulamaParamKaydetTimer = setTimeout(async () => {
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.hareketler.guncelle',
      });
      istek.parametreler = {
        filter: { _id: icerik._id },
        set: { 'ek.parametreler': icerik.ek.parametreler }
      };
      await istek.isteSync();
      this.CD.detectChanges();
    }, 800);
  }
  private _uygulamaParamKaydetTimer: any;

  private _aktifIcerikNo: number = 0;
  public get aktifIcerikNo(): number {
    return this._aktifIcerikNo;
  }
  @Input() public set aktifIcerikNo(v: number) {
    this._aktifIcerikNo = v;
    this.girilenSifre = null;
    this.sifreKutusuGoster = false;
    this.stp3dAktif = false; // 🪶 içerik değişince gömülü 3D önizleme durumu sıfırlanır
    // this.CD.detectChanges();
    if (this.referansKonteynir) {

      if (this.icerikler?.length > 0) {

        if (this.icerikler[v]?.ek?.rid != null) {
          if (!(this.referansKonteynir.length > 0)) {
            // this.referansKonteynir.clear()
            let referansBilesen: ComponentRef<IKartComponent> = this.referansKonteynir.createComponent(IKartComponent, { index: 0 });
            //@ts-ignore
            referansBilesen.instance.kart = this.icerikler[v].ek.rid;
            // referansBilesen.instance.bilesenRefeans = referansBilesen;
            // referansBilesen.instance.miReferans = true;
          } else {
            //@ts-ignore
            this.referansKonteynir.get(0)._view[this.referansKonteynir.get(0)._view.length - 1].kart = this._icerikler[v].ek.rid
          }
        }

      }
    }

    if (this._icerikler?.length > 0) {
      if (this._icerikler[this.aktifIcerikNo]?.ek?.isleniyor?.evet) {
        // Onceki isleniyor subscription'ini temizle (duplicate onleme)
        this._isleniyorSub?.unsubscribe();
        this._isleniyorSub = this.FikoYT.io.fromEvent(`FikoYT.sistem.hareketler.${this._icerikler[this.aktifIcerikNo]?.ek?._id}.isleniyor`).subscribe((k: any) => {
            k.yuzde = Number((k.yuzde).toFixed(3))
            this._icerikler[this.aktifIcerikNo].ek.isleniyor = k;
            this.CD.detectChanges();
          });
      }
    }

    this.CD.detectChanges();
  }
  //
  girilenSifre = null;
  sifreKutusuGoster = false;
  whisperYukleniyor = false;

  // Yüz etiketleme (merkezi — tüm kartlar aynı modu paylaşır)
  static _yuzEtiketModuAktif = false;
  get yuzEtiketModuAktif() { return IceriklerComponent._yuzEtiketModuAktif; }
  set yuzEtiketModuAktif(v: boolean) { IceriklerComponent._yuzEtiketModuAktif = v; }

  /** Deduplicate edilmiş yüz etiketleri — aynı kişi birden fazla gösterilmez.
   *  Oncellenmis (memoized): ayni kaynak dizi referansi ve uzunlugu ise tekrar hesaplanmaz. */
  private _benzersizYuzEtiketleriCache: IYuzEtiketi[] = [];
  private _benzersizYuzEtiketleriKaynak: any = null;
  private _benzersizYuzEtiketleriUzunluk: number = -1;
  get benzersizYuzEtiketleri(): IYuzEtiketi[] {
    const etiketler = this.aktifIcerik?.ek?.yuzEtiketleri;
    if (!etiketler?.length) return [];
    // Kaynak referansi veya uzunlugu degismediyse cache'den don
    if (etiketler === this._benzersizYuzEtiketleriKaynak && etiketler.length === this._benzersizYuzEtiketleriUzunluk) {
      return this._benzersizYuzEtiketleriCache;
    }
    const gorulenKisi = new Set<string>();
    const gorulenId = new Set<string>();
    this._benzersizYuzEtiketleriCache = etiketler.filter((e: IYuzEtiketi) => {
      if (gorulenId.has(e.id)) return false;
      gorulenId.add(e.id);
      const anahtar = e.soyagaciKisiId || e.kisiId || e.kisiIsmi || e.id;
      if (gorulenKisi.has(anahtar)) return false;
      gorulenKisi.add(anahtar);
      return true;
    });
    this._benzersizYuzEtiketleriKaynak = etiketler;
    this._benzersizYuzEtiketleriUzunluk = etiketler.length;
    return this._benzersizYuzEtiketleriCache;
  }

  // Merkezi gösterim modu — tüm kartlarda aynı (Google/Apple/Facebook/Kapalı)
  static readonly GOSTERIM_MODLARI: Array<'liste' | 'temiz' | 'etiket' | 'kapali'> = ['liste', 'temiz', 'etiket', 'kapali'];
  static readonly GOSTERIM_MOD_ETIKETLERI: Record<string, string> = {
    'liste': 'Google',
    'temiz': 'Apple',
    'etiket': 'Facebook',
    'kapali': 'Kapalı',
  };
  static _yuzGosterimModu: 'liste' | 'temiz' | 'etiket' | 'kapali' = (() => {
    try { return (localStorage.getItem('fikoyt_yuz_gosterim_modu') as any) || 'liste'; } catch { return 'liste'; }
  })();
  get yuzGosterimModu() { return IceriklerComponent._yuzGosterimModu; }
  set yuzGosterimModu(v: 'liste' | 'temiz' | 'etiket' | 'kapali') {
    IceriklerComponent._yuzGosterimModu = v;
    try { localStorage.setItem('fikoyt_yuz_gosterim_modu', v); } catch {}
  }

  // Facebook (etiket) modu: tap toggle durumu
  yuzEtiketlerGorunur = false;
  private tapPeekTimer: any = null;

  bekleyenEtiket: { x: number; y: number; w: number; h: number } | null = null;
  yuzEtiketAramaMetni = '';
  yuzEtiketAramaSonuclari: any[] = [];
  private yuzEtiketAramaTimer: any = null;
  suruklenenEtiketId: string | null = null;
  private suruklemeBilgi: { yon: string; baslangicX: number; baslangicY: number; baslangicRect: { x: number; y: number; w: number; h: number } } | null = null;

  // ─── Otomatik Yüz Tanıma (Google Photos / Facebook tarzı) ───
  otomatikYuzler: any[] = [];          // Tespit edilen ama henüz onaylanmamış yüzler
  otomatikYuzAktifIdx: number | null = null; // Öneri popup'ı açık olan yüz
  otomatikYuzAramaMetni = '';
  otomatikYuzAramaSonuclari: any[] = [];
  private otomatikYuzAramaTimer: any = null;
  private otomatikYuzSorgulandiIds = new Set<string>(); // Tekrar sorgulamayı önle

  // object-fit:contain fix — gerçek resim alanı
  resimAlani: { left: number; top: number; width: number; height: number } | null = null;
  private resimAlaniObserver: ResizeObserver | null = null;
  private sonResimEl: HTMLImageElement | null = null;

  resimYuklendi($event: Event) {
    const img = $event.target as HTMLImageElement;
    this.sonResimEl = img;
    this.resimAlaniHesapla(img);
    if (!this.resimAlaniObserver) {
      this.resimAlaniObserver = new ResizeObserver(() => {
        if (this.sonResimEl) this.resimAlaniHesapla(this.sonResimEl);
      });
    }
    const container = img.closest('.icerik-resim') || img.parentElement;
    if (container) {
      this.resimAlaniObserver.disconnect();
      this.resimAlaniObserver.observe(container);
    }
    // Otomatik yüz tanıma sonuçlarını çek
    this.otomatikYuzTespitSorgula();
    // Yeni yüz tanıma sisteminden etiketleri çözümle
    const resimIdCozumle = this.aktifIcerik?.ek?._id || this.aktifIcerik?.ek?.resimid;
    if (resimIdCozumle) this.yuzEtiketleriCozumle(resimIdCozumle);
    // Soyağacı kişilerinin resimlerini zenginleştir
    this.yuzEtiketResimlerZenginlestir();
  }

  // ─── Otomatik Yüz Tanıma Sistemi ─────────────────────────────

  /** yuz_tespit koleksiyonundan bu resmin sonuçlarını çeker */
  private async otomatikYuzTespitSorgula() {
    const icerik = this.aktifIcerik;
    const resimId = icerik?.ek?._id || icerik?.ek?.resimid;
    const icerikId = icerik?._id;

    // En az biri mevcut olmalı
    if (!icerikId && !resimId) return;

    // Dedup için önce resimId, yoksa icerikId kullan
    const dedupKey = resimId || icerikId;
    if (this.otomatikYuzSorgulandiIds.has(dedupKey)) return;
    this.otomatikYuzSorgulandiIds.add(dedupKey);

    try {
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.yuz_tespit.aggregate',
      });

      // $or ile hem icerik_id hem resim_id üzerinden sorgula
      const matchKosullari: any[] = [];
      if (icerikId) matchKosullari.push({ icerik_id: icerikId });
      if (resimId) matchKosullari.push({ resim_id: resimId });

      istek.parametreler = {
        aggregate: [
          { $match: matchKosullari.length > 1 ? { $or: matchKosullari } : matchKosullari[0] },
          { $limit: 1 },
        ],
      };
      await istek.isteSync();

      const sonuclar = istek.cevap?.sonuc;
      if (!sonuclar?.length) {
        // Henüz işlenmemiş - 5 saniye sonra tekrar dene
        this.otomatikYuzSorgulandiIds.delete(dedupKey);
        setTimeout(() => this.otomatikYuzTespitSorgula(), 5000);
        return;
      }

      const tespit = sonuclar[0];
      if (!tespit?.yuzler?.length) return;

      // Mevcut onaylanmış etiketlerin hem ID hem kişi kimlik bilgilerini al
      const mevcutEtiketIdler = new Set(
        (icerik.ek?.yuzEtiketleri || []).map((e: IYuzEtiketi) => e.id)
      );
      const mevcutKisiKimlikleri = new Set(
        (icerik.ek?.yuzEtiketleri || [])
          .map((e: IYuzEtiketi) => e.soyagaciKisiId || e.kisiId || e.kisiIsmi)
          .filter(Boolean)
      );

      // Mevcut etiketlerin pozisyon+boyut bilgilerini al (%15 mesafe kontrolü için)
      const mevcutKutular = (icerik.ek?.yuzEtiketleri || []).map((e: IYuzEtiketi) => ({
        x: e.x, y: e.y, w: e.w, h: e.h
      }));

      // Onaylanmamış yüzleri göster (zaten etiketlenmemiş olanlar — çok katmanlı filtre)
      this.otomatikYuzler = tespit.yuzler
        .filter((y: any) => {
          if (y.onaylandi || mevcutEtiketIdler.has(y.id)) return false;
          // Pozisyon bazlı overlap kontrolü: AI yüzünün (x,y,w,h) mevcut elle etiketlenmiş
          // bir yüzün (x,y,w,h) ile %15 mesafe içindeyse tamamen atla
          for (const mk of mevcutKutular) {
            const dx = Math.abs(y.x - mk.x);
            const dy = Math.abs(y.y - mk.y);
            const dw = Math.abs(y.w - mk.w);
            const dh = Math.abs(y.h - mk.h);
            if (dx < 15 && dy < 15 && dw < 15 && dh < 15) return false;
          }
          return true;
        })
        .map((y: any) => {
          // Eşleşmeler içinden zaten etiketlenmiş kişileri filtrele
          const filtrelenmisEslesmeler = (y.eslesmeler || []).filter((e: any) =>
            !mevcutKisiKimlikleri.has(e.kisi_id) && !mevcutKisiKimlikleri.has(e.ad)
          );
          return {
            ...y,
            eslesmeler: filtrelenmisEslesmeler,
            enYakinEslesme: filtrelenmisEslesmeler.length > 0 ? filtrelenmisEslesmeler[0] : null,
          };
        });

      this.yuzEtiketResimlerZenginlestir();
      this.CD.detectChanges();
    } catch (e) {
      // Sessizce geç - servis henüz hazır olmayabilir
    }
  }

  // ─── Yüz Etiket Çözümleme (yuz_embeddingler + kullanıcı etiketleri) ────
  private _yuzCozumlemeYapildi = new Set<string>();

  /**
   * Yeni yüz tanıma sisteminden etiketleri çözümler.
   * yuz_embeddingler koleksiyonundan resim yüzlerini çeker,
   * görenin ve paylaşanın etiketlerini birleştirip IYuzEtiketi formatına dönüştürür.
   */
  private async yuzEtiketleriCozumle(resimId: string) {
    if (!resimId || this._yuzCozumlemeYapildi.has(resimId)) return;
    if (!_etiketleriCozumle) return;
    this._yuzCozumlemeYapildi.add(resimId);

    try {
      // 1. Bu resmin embedding kayıtlarını çek
      const embedIstek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.yuz_embeddingler.aggregate' });
      embedIstek.parametreler = { aggregate: [{ $match: { resimId, durum: 'tamamlandi' } }, { $limit: 1 }] };
      await embedIstek.isteSync();
      const embedSonuc = embedIstek.cevap?.sonuc;
      if (!embedSonuc?.length || !embedSonuc[0]?.yuzler?.length) return;
      const yuzler = embedSonuc[0].yuzler;
      const kaynakSahibiId = embedSonuc[0].kaynakSahibiId;

      // 2. Görüntüleyen kullanıcının etiketlerini çek
      const goruntuleyenId = this.FikoYT.kimlik.aktifKullaniciJson()?._id;
      if (!goruntuleyenId) return;
      const grupIdler = yuzler.map((y: any) => y.kisiGrupId).filter(Boolean);
      if (!grupIdler.length) return;

      const etiketSorgula = async (kullaniciId: string) => {
        const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.yuz_kullanici_etiketleri.aggregate' });
        istek.parametreler = { aggregate: [{ $match: { kullaniciId, kisiGrupId: { $in: grupIdler } } }] };
        await istek.isteSync();
        return istek.cevap?.sonuc || [];
      };

      const [gorenEtiketler, paylasanEtiketler] = await Promise.all([
        etiketSorgula(goruntuleyenId),
        kaynakSahibiId && kaynakSahibiId !== goruntuleyenId
          ? etiketSorgula(kaynakSahibiId)
          : Promise.resolve([]),
      ]);

      // 3. Map'lere dönüştür
      const gorenMap = new Map<string, any>();
      for (const e of (gorenEtiketler || [])) gorenMap.set(e.kisiGrupId, e);
      const paylasanMap = new Map<string, any>();
      for (const e of (paylasanEtiketler || [])) paylasanMap.set(e.kisiGrupId, e);

      // 4. Çözümle
      const cozumlenmis = _etiketleriCozumle(yuzler, gorenMap, paylasanMap);
      if (!cozumlenmis?.length) return;

      // 5. IYuzEtiketi formatına dönüştür
      const mevcutEtiketler = this.aktifIcerik?.ek?.yuzEtiketleri || [];
      const mevcutGrupIdler = new Set(mevcutEtiketler.map((e: IYuzEtiketi) => e.kisiId).filter(Boolean));

      const yeniEtiketler: IYuzEtiketi[] = cozumlenmis
        .filter((c: any) => !c.kisiGrupId || !mevcutGrupIdler.has(c.kisiGrupId))
        .map((c: any, idx: number) => ({
          id: 'yt_' + (c.kisiGrupId || ('bilinmeyen_' + Date.now().toString(36) + '_' + idx)),
          x: c.bbox?.x ?? 0,
          y: c.bbox?.y ?? 0,
          w: c.bbox?.w ?? 10,
          h: c.bbox?.h ?? 12,
          kisiId: c.kisiGrupId || undefined,
          kisiIsmi: c.isim || 'Bilinmeyen',
          soyagaciKisiId: c.soyagaciKisiId || undefined,
          resimUrl: c.resimUrl || undefined,
        }));

      if (!yeniEtiketler.length) return;

      // 6. Mevcut etiketlere ekle
      if (!this.aktifIcerik?.ek) return;
      if (!this.aktifIcerik.ek.yuzEtiketleri) this.aktifIcerik.ek.yuzEtiketleri = [];
      this.aktifIcerik.ek.yuzEtiketleri.push(...yeniEtiketler);
      this.CD.detectChanges();
    } catch {
      // Sessizce devam — yüz tanıma servisi hazır olmayabilir
    }
  }

  /** Otomatik tespit edilen yüzü onayla (önerilen kişi ile veya yeni isimle) */
  otomatikYuzOnayla(yuzIdx: number, kisi?: { _id?: string; ismi: string; kaynak?: string; soyagaciKisiId?: string; resimUrl?: string }) {
    const yuz = this.otomatikYuzler[yuzIdx];
    if (!yuz || !this.aktifIcerik?.ek) return;
    if (!this.aktifIcerik.ek.yuzEtiketleri) this.aktifIcerik.ek.yuzEtiketleri = [];

    // IYuzEtiketi formatında ekle
    const etiket: IYuzEtiketi = {
      id: yuz.id || Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      x: yuz.x,
      y: yuz.y,
      w: yuz.w,
      h: yuz.h,
      kisiIsmi: kisi?.ismi || yuz.enYakinEslesme?.ad || this.otomatikYuzAramaMetni || 'Bilinmeyen',
      kisiId: kisi?.kaynak === 'platform' ? kisi._id : (yuz.enYakinEslesme?.kisi_id || undefined),
      soyagaciKisiId: kisi?.soyagaciKisiId || undefined,
      resimUrl: kisi?.resimUrl || yuz.enYakinEslesme?.resim_url || undefined,
    };

    this.aktifIcerik.ek.yuzEtiketleri.push(etiket);
    this.otomatikYuzler.splice(yuzIdx, 1);

    // Onaylanan kişiyi kalan otomatikYuzler'deki eşleşmelerden çıkar
    const onaylananKisiIdler = new Set(
      [etiket.kisiId, etiket.soyagaciKisiId, etiket.kisiIsmi].filter(Boolean)
    );
    for (const kalanYuz of this.otomatikYuzler) {
      if (kalanYuz.eslesmeler?.length) {
        kalanYuz.eslesmeler = kalanYuz.eslesmeler.filter(
          (e: any) => !onaylananKisiIdler.has(e.kisi_id) && !onaylananKisiIdler.has(e.ad)
        );
        // enYakinEslesme güncelle: filtrelenmiş listeden ilk eleman veya null
        if (kalanYuz.enYakinEslesme &&
            (onaylananKisiIdler.has(kalanYuz.enYakinEslesme.kisi_id) ||
             onaylananKisiIdler.has(kalanYuz.enYakinEslesme.ad))) {
          kalanYuz.enYakinEslesme = kalanYuz.eslesmeler.length > 0 ? kalanYuz.eslesmeler[0] : null;
        }
      }
    }

    this.otomatikYuzAktifIdx = null;
    this.otomatikYuzAramaMetni = '';
    this.otomatikYuzAramaSonuclari = [];

    // Tanınan kişi descriptor'ını kaydet (gelecek tanımalar için)
    if (yuz.descriptor?.length && etiket.kisiIsmi) {
      this.otomatikYuzTaninanKaydet(etiket, yuz.descriptor);
    }

    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  /** Otomatik tespit edilen yüzü reddet (gösterme) */
  otomatikYuzReddet(yuzIdx: number) {
    this.otomatikYuzler.splice(yuzIdx, 1);
    this.otomatikYuzAktifIdx = null;
    this.CD.detectChanges();
  }

  /** En yakın eşleşmeyi hızlı onayla (tek tıkla) */
  otomatikYuzHizliOnayla(yuzIdx: number) {
    const yuz = this.otomatikYuzler[yuzIdx];
    if (!yuz?.enYakinEslesme) return;
    this.otomatikYuzOnayla(yuzIdx, {
      ismi: yuz.enYakinEslesme.ad,
      _id: yuz.enYakinEslesme.kisi_id,
      resimUrl: yuz.enYakinEslesme.resim_url,
    });
  }

  /** Otomatik yüz için kişi arama */
  otomatikYuzAra(metin: string) {
    this.otomatikYuzAramaMetni = metin;
    if (this.otomatikYuzAramaTimer) clearTimeout(this.otomatikYuzAramaTimer);
    if (!metin || metin.length < 2) {
      this.otomatikYuzAramaSonuclari = [];
      this.CD.detectChanges();
      return;
    }
    // Mevcut arama fonksiyonunu kullan
    this.otomatikYuzAramaTimer = setTimeout(() => {
      this.yuzEtiketAra(metin);
      // Sonuçları otomatik yüz aramasına kopyala
      setTimeout(() => {
        this.otomatikYuzAramaSonuclari = [...this.yuzEtiketAramaSonuclari];
        this.CD.detectChanges();
      }, 400);
    }, 300);
  }

  /** Onaylanan yüzün descriptor'ını yuz_taninan'a kaydet */
  private async otomatikYuzTaninanKaydet(etiket: IYuzEtiketi, descriptor: number[]) {
    try {
      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      const kisiId = etiket.kisiId || etiket.soyagaciKisiId || etiket.id;

      const formData = new FormData();
      formData.append('req_body', JSON.stringify({
        kisi_id: kisiId,
        kullanici_id: this.kart?.sahip,
        ad: etiket.kisiIsmi,
        ortalama_descriptor: descriptor,
        foto_sayisi: 1,
        tarih: new Date(),
      }));
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.yuz_taninan.ekle`, {
        method: 'POST',
        body: formData,
      });

      // Yeni kişi kaydedildikten sonra tüm eski tespitleri tekrar eşleştir
      fetch(`${baseUrl}/api/yuz-tanima/yeniden-eslesme`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kullanici_id: this.kart?.sahip }),
      }).then(() => {
        // Sunucu eşleştirmeyi bitirdikten sonra cache'i temizle ve tekrar sorgula
        setTimeout(() => {
          this.otomatikYuzSorgulandiIds.clear();
          this.otomatikYuzTespitSorgula();
        }, 1500);
      }).catch(() => {});
    } catch (e) {
      console.warn('Tanınan kişi kayıt hatası:', e);
    }
  }

  private resimAlaniHesapla(img: HTMLImageElement) {
    const container = img.closest('.icerik-resim') || img.parentElement;
    if (!container) return;
    const cRect = container.getBoundingClientRect();
    const bounds = this.resimGercekBounds(img, cRect);
    this.resimAlani = {
      left: ((bounds.left - cRect.left) / cRect.width) * 100,
      top: ((bounds.top - cRect.top) / cRect.height) * 100,
      width: (bounds.width / cRect.width) * 100,
      height: (bounds.height / cRect.height) * 100,
    };
    this.CD.detectChanges();
  }

  private resimGercekBounds(img: HTMLImageElement, cRect: DOMRect) {
    const natW = img.naturalWidth || 1;
    const natH = img.naturalHeight || 1;
    const fit = getComputedStyle(img).objectFit || 'contain';
    let scale: number;
    if (fit === 'cover') {
      scale = Math.max(cRect.width / natW, cRect.height / natH);
    } else {
      // contain, scale-down, vb.
      scale = Math.min(cRect.width / natW, cRect.height / natH);
    }
    const rW = natW * scale;
    const rH = natH * scale;
    return {
      left: cRect.left + (cRect.width - rW) / 2,
      top: cRect.top + (cRect.height - rH) / 2,
      width: rW,
      height: rH,
    };
  }

  /** Touch veya Mouse event'ten clientX/clientY çıkarır */
  private dokunmaKoordinat(e: MouseEvent | TouchEvent): { clientX: number; clientY: number } | null {
    if ('touches' in e) {
      const t = e.touches[0] || e.changedTouches[0];
      return t ? { clientX: t.clientX, clientY: t.clientY } : null;
    }
    return { clientX: e.clientX, clientY: e.clientY };
  }

  private katmanBoyutAl($event: MouseEvent | TouchEvent): { width: number; height: number; left: number; top: number } | null {
    const target = ('touches' in $event ? $event.target : $event.target) as HTMLElement;
    const katman = target?.closest('.yuz-etiket-katman');
    if (katman) {
      const r = katman.getBoundingClientRect();
      return { width: r.width, height: r.height, left: r.left, top: r.top };
    }
    const container = target?.closest('.icerik-resim') || target?.closest('.icerik-ekreferans');
    if (container) return container.getBoundingClientRect();
    return null;
  }

  tiklandiResimEtiketle($event: MouseEvent) {
    if (!this.yuzEtiketModuAktif || !this.miSahip) return;
    const bounds = this.katmanBoyutAl($event);
    if (!bounds) return;
    const xPct = (($event.clientX - bounds.left) / bounds.width) * 100;
    const yPct = (($event.clientY - bounds.top) / bounds.height) * 100;
    const w = 12, h = 15;
    this.bekleyenEtiket = {
      x: Math.max(0, Math.min(100 - w, xPct - w / 2)),
      y: Math.max(0, Math.min(100 - h, yPct - h / 2)),
      w, h,
    };
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketAra(metin: string) {
    this.yuzEtiketAramaMetni = metin;
    if (this.yuzEtiketAramaTimer) clearTimeout(this.yuzEtiketAramaTimer);
    if (!metin || metin.length < 2) {
      this.yuzEtiketAramaSonuclari = [];
      this.CD.detectChanges();
      return;
    }
    this.yuzEtiketAramaTimer = setTimeout(async () => {
      try {
        // 1) Platform kullanıcıları ara
        const istek = new FikoYTIstekKok({
          metod: 'POST',
          komut: 'FikoYT.sistem.DB.goUyeler.aggregate',
        });
        istek.parametreler = {
          aggregate: [
            { $match: { 'veri.pilesmi': { $regex: escapeRegex(metin), $options: 'i' } } },
            { $limit: 8 },
            { $project: { _id: 1, 'veri.pilesmi': 1 } }
          ]
        };
        await istek.isteSync();
        const platformSonuc = (istek.cevap?.sonuc || []).map((k: any) => ({
          _id: k._id,
          ismi: k.veri?.pilesmi || k._id,
          kaynak: 'platform',
        }));

        // 2) Soyağacı kişilerini ara
        let soyagaciSonuc: any[] = [];
        try {
          const soyIstek = new FikoYTIstekKok({
            metod: 'POST',
            komut: 'FikoYT.sistem.DB.hareketler.aggregate',
          });
          soyIstek.parametreler = {
            aggregate: [
              { $match: {
                vt: 'FikoYT.sistem.soyAgaciKisiler',
                silindi: { $ne: true },
                $or: [
                  { 'veri.isim': { $regex: escapeRegex(metin), $options: 'i' } },
                  { 'veri.soyIsim': { $regex: escapeRegex(metin), $options: 'i' } },
                ]
              }},
              { $limit: 8 },
              { $project: { _id: 1, 'veri.isim': 1, 'veri.soyIsim': 1, 'veri.resimUrl': 1 } }
            ]
          };
          await soyIstek.isteSync();
          soyagaciSonuc = (soyIstek.cevap?.sonuc || []).map((k: any) => ({
            _id: 'soyagaci:' + k._id,
            soyagaciKisiId: k._id,
            ismi: ((k.veri?.isim || '') + ' ' + (k.veri?.soyIsim || '')).trim(),
            resimUrl: k.veri?.resimUrl,
            kaynak: 'soyagaci',
          }));
        } catch (e) {}

        this.yuzEtiketAramaSonuclari = [...soyagaciSonuc, ...platformSonuc];
      } catch (e) {
        this.yuzEtiketAramaSonuclari = [];
      }
      this.CD.detectChanges();
    }, 300);
  }

  bekleyenEtiketIptal() {
    this.bekleyenEtiket = null;
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketEkle(kisi?: { _id?: string; ismi: string; kaynak?: string; soyagaciKisiId?: string; resimUrl?: string }) {
    if (!this.bekleyenEtiket || !this.aktifIcerik?.ek) return;
    if (!this.aktifIcerik.ek.yuzEtiketleri) this.aktifIcerik.ek.yuzEtiketleri = [];
    const etiket: IYuzEtiketi = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      x: this.bekleyenEtiket.x,
      y: this.bekleyenEtiket.y,
      w: this.bekleyenEtiket.w,
      h: this.bekleyenEtiket.h,
      kisiIsmi: kisi?.ismi || this.yuzEtiketAramaMetni,
      kisiId: kisi?.kaynak === 'platform' ? kisi._id : (kisi?._id && !kisi?.soyagaciKisiId ? kisi._id : undefined),
      soyagaciKisiId: kisi?.soyagaciKisiId || undefined,
      resimUrl: kisi?.resimUrl || undefined,
    };
    this.aktifIcerik.ek.yuzEtiketleri.push(etiket);
    this.bekleyenEtiket = null;
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  yuzEtiketSil(id: string) {
    if (!this.aktifIcerik?.ek?.yuzEtiketleri) return;
    this.aktifIcerik.ek.yuzEtiketleri = this.aktifIcerik.ek.yuzEtiketleri.filter((e: IYuzEtiketi) => e.id !== id);
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  private _resimZenginlestirmeYapildi = new Set<string>();

  /** Etiketlerdeki kişilerin resimUrl'ini soyağacından toplu çekip yaz */
  private async yuzEtiketResimlerZenginlestir() {
    const etiketler = this.aktifIcerik?.ek?.yuzEtiketleri as IYuzEtiketi[];
    if (!etiketler?.length) return;

    // resimUrl eksik olan etiketlerin tüm ID'lerini topla (soyagaciKisiId VEYA kisiId)
    const araIdler: string[] = [];
    const etiketIdMap = new Map<string, IYuzEtiketi[]>(); // id -> etiketler
    for (const e of etiketler) {
      if (e.resimUrl) continue;
      const id = e.soyagaciKisiId || e.kisiId;
      if (!id || this._resimZenginlestirmeYapildi.has(id)) continue;
      araIdler.push(id);
      this._resimZenginlestirmeYapildi.add(id);
      if (!etiketIdMap.has(id)) etiketIdMap.set(id, []);
      etiketIdMap.get(id)!.push(e);
    }
    if (!araIdler.length) return;

    try {
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
      istek.parametreler = {
        aggregate: [
          { $match: {
            vt: 'FikoYT.sistem.soyAgaciKisiler',
            silindi: { $ne: true },
            $or: [
              { _id: { $in: araIdler } },
              { 'veri.platformKullaniciId': { $in: araIdler } },
            ]
          } },
          { $project: { 'veri.resimUrl': 1, 'veri.platformKullaniciId': 1 } }
        ]
      };
      await istek.isteSync();
      const sonuclar = istek.cevap?.sonuc || [];

      let degisti = false;
      for (const s of sonuclar) {
        if (!s.veri?.resimUrl) continue;
        // _id ile eşleşen etiketler
        const byId = etiketIdMap.get(s._id);
        if (byId) for (const e of byId) { e.resimUrl = s.veri.resimUrl; degisti = true; }
        // platformKullaniciId ile eşleşen etiketler
        if (s.veri.platformKullaniciId) {
          const byPlatform = etiketIdMap.get(s.veri.platformKullaniciId);
          if (byPlatform) for (const e of byPlatform) { e.resimUrl = s.veri.resimUrl; degisti = true; }
        }
      }
      if (degisti) this.CD.detectChanges();
    } catch {}
  }

  duzenlenenEtiketId: string | null = null;
  duzenlenenEtiketIsmi = '';
  acikBalonEtiketId: string | null = null;

  // KisiBalonV2 callback'leri — kişi detay ve navigasyon
  balonKisiDetayCekFn = (kisiId: string) => this.soyAgaci.kisiDetayVeIliskilerCek(kisiId);

  balonKisiyeGitFn = (kisiId: string, tip: 'soyagaci' | 'profil' | 'agac') => {
    if (tip === 'soyagaci') this.router.navigate(['/\u{1F9E9}/\u{1F333}/kisi', kisiId]);
    else if (tip === 'agac') this.router.navigate(['/\u{1F9E9}/\u{1F333}'], { queryParams: { odakla: kisiId } });
  };

  get acikBalonEtiket(): IYuzEtiketi | null {
    if (!this.acikBalonEtiketId) return null;
    return this.aktifIcerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === this.acikBalonEtiketId) || null;
  }

  popoverGorunurlukDegisti(gorunur: boolean, etiket: IYuzEtiketi) {
    if (gorunur) {
      this.acikBalonEtiketId = etiket.id;
      if (this.miSahip && this.yuzEtiketModuAktif) {
        this.duzenlenenEtiketId = etiket.id;
        this.duzenlenenEtiketIsmi = etiket.kisiIsmi;
        this.yuzEtiketAramaMetni = etiket.kisiIsmi;
        this.yuzEtiketAramaSonuclari = [];
      }
    } else {
      this.acikBalonEtiketId = null;
      this.duzenlenenEtiketId = null;
    }
    this.CD.detectChanges();
  }

  /** Aktif içeriğin yüz crop resim URL'i (yuz-crop bileşeni için) */
  get yuzKirpResimUrl(): string {
    const ek = this.aktifIcerik?.ek;
    if (!ek?._id) return '';
    const resimTuru = ek.turu === 'RESIM' || (ek.turu === 'EKREFERANS' && ek.bilgiler?.orijinalTuru === 'RESIM');
    const icerikId = resimTuru ? ek._id : ek.resimid;
    if (!icerikId) return '';
    return resimTuru
      ? `${this.FikoYT.fapiUrl}/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.${icerikId}.resim?boyut=480x?`
      : `${this.FikoYT.fapiUrl}/fikoyt.com.FikoYT.sistem.aktifKullanici.hareketler.${icerikId}.dosyaResim?boyut=480x?`;
  }

  etiketTiklandi(etiket: IYuzEtiketi) {
    if (this.miSahip && this.yuzEtiketModuAktif) {
      // Etiketleme modunda: düzenleme arama kutusunu aç
      this.duzenlenenEtiketId = etiket.id;
      this.duzenlenenEtiketIsmi = etiket.kisiIsmi;
      this.yuzEtiketAramaMetni = etiket.kisiIsmi;
      this.yuzEtiketAramaSonuclari = [];
      this.acikBalonEtiketId = etiket.id;
    } else {
      // Normal mod: kişi kartı toggle
      this.acikBalonEtiketId = this.acikBalonEtiketId === etiket.id ? null : etiket.id;
      this.duzenlenenEtiketId = null;
    }
    this.CD.detectChanges();
  }

  /** kisi-balon-v2 düzenleme kaydet/başlat callback */
  balonDuzenleKaydet(sonuc: any) {
    if (sonuc?._duzenlemeBaslat) {
      // İşlemler sekmesinden "Düzenle" tıklandı
      this.duzenlenenEtiketId = this.acikBalonEtiketId;
      this.CD.detectChanges();
      return;
    }
    // Kaydet
    this.yuzEtiketDuzenleKaydet(sonuc);
  }

  /** Yüz etiketine tıklanınca kişi sayfasına git (liste modu ve doğrudan navigasyon) */
  yuzEtiketKisiSayfasinaGit(etiket: IYuzEtiketi) {
    const hedefId = etiket.soyagaciKisiId || etiket.kisiId;
    if (!hedefId) return;
    // soyagaciKisiId varsa veya kisiId ObjectId (24 hex) ise soyagaci kisi sayfasi
    if (etiket.soyagaciKisiId || /^[a-f0-9]{24}$/i.test(hedefId)) {
      this.router.navigate(['/🧩/🌳/kisi', hedefId]);
    } else {
      this.router.navigate(['/🧩/🕸', hedefId]);
    }
  }

  yuzEtiketDuzenleBasla(etiket: IYuzEtiketi) {
    this.duzenlenenEtiketId = etiket.id;
    this.duzenlenenEtiketIsmi = etiket.kisiIsmi;
    this.yuzEtiketAramaMetni = etiket.kisiIsmi;
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketDuzenleKaydet(kisi?: { _id?: string; ismi: string; kaynak?: string; soyagaciKisiId?: string; resimUrl?: string }) {
    if (!this.duzenlenenEtiketId) return;
    const etiket = this.aktifIcerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === this.duzenlenenEtiketId);
    if (!etiket) return;
    etiket.kisiIsmi = kisi?.ismi || this.duzenlenenEtiketIsmi;
    etiket.kisiId = kisi?.kaynak === 'platform' ? kisi._id : (kisi?._id && !kisi?.soyagaciKisiId ? kisi._id : etiket.kisiId);
    etiket.soyagaciKisiId = kisi?.soyagaciKisiId || etiket.soyagaciKisiId;
    if (kisi?.resimUrl) etiket.resimUrl = kisi.resimUrl;
    this.duzenlenenEtiketId = null;
    this.duzenlenenEtiketIsmi = '';
    this.acikBalonEtiketId = null;
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  yuzEtiketDuzenleIptal() {
    this.duzenlenenEtiketId = null;
    this.duzenlenenEtiketIsmi = '';
    this.acikBalonEtiketId = null;
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  /** Düzenlenen etiketin % pozisyonu (popup konumlandırma için) */
  get duzenlenenEtiketPozisyon(): { x: number; y: number } | null {
    if (!this.duzenlenenEtiketId) return null;
    const etiket = this.aktifIcerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === this.duzenlenenEtiketId);
    if (!etiket) return null;
    return { x: etiket.x + etiket.w / 2, y: etiket.y + etiket.h };
  }

  katmanTiklandi($event: MouseEvent) {
    if (!this.yuzEtiketModuAktif || !this.miSahip) return;
    if (this.bekleyenEtiket) return;
    $event.stopPropagation();
    const rect = ($event.currentTarget as HTMLElement).getBoundingClientRect();
    const xPct = (($event.clientX - rect.left) / rect.width) * 100;
    const yPct = (($event.clientY - rect.top) / rect.height) * 100;
    const w = 12, h = 15;
    this.bekleyenEtiket = {
      x: Math.max(0, Math.min(100 - w, xPct - w / 2)),
      y: Math.max(0, Math.min(100 - h, yPct - h / 2)),
      w, h,
    };
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketGosterimDegistir() {
    const modlar = IceriklerComponent.GOSTERIM_MODLARI;
    const idx = modlar.indexOf(this.yuzGosterimModu);
    this.yuzGosterimModu = modlar[(idx + 1) % modlar.length];
    this.yuzEtiketlerGorunur = false;
    // Tüm kartları bilgilendir (merkezi mod değişti)
    this.FikoYT.degisti.emit();
  }

  /** Facebook modu: resme tap → etiketleri göster/gizle toggle */
  yuzEtiketTapToggle() {
    if (this.yuzGosterimModu !== 'etiket') return;
    this.yuzEtiketlerGorunur = !this.yuzEtiketlerGorunur;
    this.CD.detectChanges();
  }

  /** Google modu: resme tap → 1.5sn çerçeve peek → otomatik gizle */
  yuzEtiketTapPeek() {
    if (this.yuzGosterimModu !== 'liste') return;
    if (this.tapPeekTimer) clearTimeout(this.tapPeekTimer);
    this.yuzEtiketlerGorunur = true;
    this.CD.detectChanges();
    this.tapPeekTimer = setTimeout(() => {
      this.yuzEtiketlerGorunur = false;
      this.CD.detectChanges();
    }, 1500);
  }

  /** Resme tıklama/dokunma — mod bazlı davranış */
  resimTapHandler($event: Event) {
    if (this.yuzEtiketModuAktif) return; // Düzenleme modundayken karışma
    if (this.yuzGosterimModu === 'etiket') {
      this.yuzEtiketTapToggle();
    } else if (this.yuzGosterimModu === 'liste') {
      this.yuzEtiketTapPeek();
    }
  }

  cerceveTasimaBasla($event: MouseEvent | TouchEvent, etiketId: string) {
    $event.preventDefault();
    $event.stopPropagation();
    const etiket = this.aktifIcerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === etiketId);
    if (!etiket) return;
    const kor = this.dokunmaKoordinat($event);
    if (!kor) return;
    const startX = kor.clientX;
    const startY = kor.clientY;
    const baslangic = { x: etiket.x, y: etiket.y };
    const katmanBoyut = this.katmanBoyutAl($event);
    if (!katmanBoyut) return;
    const sabitW = katmanBoyut.width;
    const sabitH = katmanBoyut.height;
    const hareket = (e: MouseEvent | TouchEvent) => {
      const k = this.dokunmaKoordinat(e);
      if (!k) return;
      const dx = ((k.clientX - startX) / sabitW) * 100;
      const dy = ((k.clientY - startY) / sabitH) * 100;
      etiket.x = Math.max(0, Math.min(100 - etiket.w, baslangic.x + dx));
      etiket.y = Math.max(0, Math.min(100 - etiket.h, baslangic.y + dy));
      this.CD.detectChanges();
    };
    const birak = () => {
      document.removeEventListener('mousemove', hareket);
      document.removeEventListener('mouseup', birak);
      document.removeEventListener('touchmove', hareket);
      document.removeEventListener('touchend', birak);
      this.yuzEtiketleriKaydet();
    };
    document.addEventListener('mousemove', hareket);
    document.addEventListener('mouseup', birak);
    document.addEventListener('touchmove', hareket, { passive: false });
    document.addEventListener('touchend', birak);
  }

  cerceveBoyutlandirBasla($event: MouseEvent | TouchEvent, etiketId: string, yon: string) {
    $event.preventDefault();
    $event.stopPropagation();
    const etiket = this.aktifIcerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === etiketId);
    if (!etiket) return;
    const kor = this.dokunmaKoordinat($event);
    if (!kor) return;
    this.suruklenenEtiketId = etiketId;
    this.suruklemeBilgi = {
      yon,
      baslangicX: kor.clientX,
      baslangicY: kor.clientY,
      baslangicRect: { x: etiket.x, y: etiket.y, w: etiket.w, h: etiket.h },
    };
    const katmanBoyut = this.katmanBoyutAl($event);
    if (!katmanBoyut) return;
    const sabitW = katmanBoyut.width;
    const sabitH = katmanBoyut.height;
    const hareket = (e: MouseEvent | TouchEvent) => {
      if (!this.suruklemeBilgi || !this.suruklenenEtiketId) return;
      const et = this.aktifIcerik?.ek?.yuzEtiketleri?.find((t: IYuzEtiketi) => t.id === this.suruklenenEtiketId);
      if (!et) return;
      const k = this.dokunmaKoordinat(e);
      if (!k) return;
      const dx = ((k.clientX - this.suruklemeBilgi.baslangicX) / sabitW) * 100;
      const dy = ((k.clientY - this.suruklemeBilgi.baslangicY) / sabitH) * 100;
      const b = this.suruklemeBilgi.baslangicRect;
      const y = this.suruklemeBilgi.yon;
      const min = 5;
      if (y.includes('e')) { et.w = Math.max(min, Math.min(100 - b.x, b.w + dx)); }
      if (y.includes('w')) { et.x = Math.min(b.x + b.w - min, b.x + dx); et.w = Math.max(min, b.w - dx); }
      if (y.includes('s')) { et.h = Math.max(min, Math.min(100 - b.y, b.h + dy)); }
      if (y.includes('n')) { et.y = Math.min(b.y + b.h - min, b.y + dy); et.h = Math.max(min, b.h - dy); }
      this.CD.detectChanges();
    };
    const birak = () => {
      document.removeEventListener('mousemove', hareket);
      document.removeEventListener('mouseup', birak);
      document.removeEventListener('touchmove', hareket);
      document.removeEventListener('touchend', birak);
      this.suruklenenEtiketId = null;
      this.suruklemeBilgi = null;
      this.yuzEtiketleriKaydet();
    };
    document.addEventListener('mousemove', hareket);
    document.addEventListener('mouseup', birak);
    document.addEventListener('touchmove', hareket, { passive: false });
    document.addEventListener('touchend', birak);
  }

  bekleyenCerceveTasimaBasla($event: MouseEvent | TouchEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    if (!this.bekleyenEtiket) return;
    const kor = this.dokunmaKoordinat($event);
    if (!kor) return;
    const startX = kor.clientX;
    const startY = kor.clientY;
    const baslangic = { x: this.bekleyenEtiket.x, y: this.bekleyenEtiket.y };
    const katmanBoyut = this.katmanBoyutAl($event);
    if (!katmanBoyut) return;
    const sabitW = katmanBoyut.width;
    const sabitH = katmanBoyut.height;
    const hareket = (e: MouseEvent | TouchEvent) => {
      if (!this.bekleyenEtiket) return;
      const k = this.dokunmaKoordinat(e);
      if (!k) return;
      const dx = ((k.clientX - startX) / sabitW) * 100;
      const dy = ((k.clientY - startY) / sabitH) * 100;
      this.bekleyenEtiket.x = Math.max(0, Math.min(100 - this.bekleyenEtiket.w, baslangic.x + dx));
      this.bekleyenEtiket.y = Math.max(0, Math.min(100 - this.bekleyenEtiket.h, baslangic.y + dy));
      this.CD.detectChanges();
    };
    const birak = () => {
      document.removeEventListener('mousemove', hareket);
      document.removeEventListener('mouseup', birak);
      document.removeEventListener('touchmove', hareket);
      document.removeEventListener('touchend', birak);
    };
    document.addEventListener('mousemove', hareket);
    document.addEventListener('mouseup', birak);
    document.addEventListener('touchmove', hareket, { passive: false });
    document.addEventListener('touchend', birak);
  }

  bekleyenCerceveBoyutlandirBasla($event: MouseEvent | TouchEvent, yon: string) {
    $event.preventDefault();
    $event.stopPropagation();
    if (!this.bekleyenEtiket) return;
    const kor = this.dokunmaKoordinat($event);
    if (!kor) return;
    const baslangic = { ...this.bekleyenEtiket };
    const startX = kor.clientX;
    const startY = kor.clientY;
    const katmanBoyut = this.katmanBoyutAl($event);
    if (!katmanBoyut) return;
    const sabitW = katmanBoyut.width;
    const sabitH = katmanBoyut.height;
    const hareket = (e: MouseEvent | TouchEvent) => {
      if (!this.bekleyenEtiket) return;
      const k = this.dokunmaKoordinat(e);
      if (!k) return;
      const dx = ((k.clientX - startX) / sabitW) * 100;
      const dy = ((k.clientY - startY) / sabitH) * 100;
      const min = 5;
      if (yon.includes('e')) { this.bekleyenEtiket.w = Math.max(min, Math.min(100 - baslangic.x, baslangic.w + dx)); }
      if (yon.includes('w')) { this.bekleyenEtiket.x = Math.min(baslangic.x + baslangic.w - min, baslangic.x + dx); this.bekleyenEtiket.w = Math.max(min, baslangic.w - dx); }
      if (yon.includes('s')) { this.bekleyenEtiket.h = Math.max(min, Math.min(100 - baslangic.y, baslangic.h + dy)); }
      if (yon.includes('n')) { this.bekleyenEtiket.y = Math.min(baslangic.y + baslangic.h - min, baslangic.y + dy); this.bekleyenEtiket.h = Math.max(min, baslangic.h - dy); }
      this.CD.detectChanges();
    };
    const birak = () => {
      document.removeEventListener('mousemove', hareket);
      document.removeEventListener('mouseup', birak);
      document.removeEventListener('touchmove', hareket);
      document.removeEventListener('touchend', birak);
    };
    document.addEventListener('mousemove', hareket);
    document.addEventListener('mouseup', birak);
    document.addEventListener('touchmove', hareket, { passive: false });
    document.addEventListener('touchend', birak);
  }

  private async yuzEtiketleriKaydet() {
    const icerik = this.aktifIcerik;
    if (!icerik?._id) return;
    try {
      const guncelleme: any = {
        _id: icerik._id,
        'ek.yuzEtiketleri': icerik.ek.yuzEtiketleri || [],
        'ek.yuzEtiketGosterim': icerik.ek.yuzEtiketGosterim || 'hover',
      };
      const formData = new FormData();
      formData.append('req_body', JSON.stringify(guncelleme));
      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });
    } catch (e) {
      console.warn('Yüz etiketleri kayıt hatası:', e);
    }
  }

  // TrackBy fonksiyonlari - ngFor performansi icin
  trackByEtiketId = (_: number, etiket: IYuzEtiketi) => etiket.id;
  trackByIndex = (i: number) => i;
  trackById = (_: number, item: any) => item._id || item.id;
  trackByKisiId = (_: number, item: any) => item.kisi_id || item._id || item.ismi;

  // Referans Drawer
  referansDrawerAcik = false;
  referansDrawerVeri: any = null;
  referansZinciri: any[] = [];
  zincirYukleniyor = false;

  async tiklandiReferansDetay(icerik: any) {
    const ek = icerik?.ek;
    if (!ek?.bilgiler) return;

    this.referansDrawerVeri = {
      orijinalTuru: ek.bilgiler.orijinalTuru,
      sahip: ek.bilgiler.sahip,
      sahipIsim: ek.bilgiler.sahipIsim,
      kartId: ek.bilgiler.kartId,
      orijinalTarih: ek.bilgiler.orijinalTarih,
      referansSayisi: ek.bilgilers?.referansSayisi || ek.bilgiler.referansSayisi || 1,
      ekId: ek._id,
      thumbnailUrl: this.FikoYT.fapiUrl + '/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.' + ek._id + '.resim?boyut=300x?&t=0',
      sahipResimUrl: this.FikoYT.fapiUrl + '/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.' + ek.bilgiler.sahip + '.resim?boyut=60x?&t=0',
    };
    this.referansZinciri = [];
    this.referansDrawerAcik = true;
    this.CD.detectChanges();

    // Referans zincirini yükle
    if (ek.bilgiler.kartId) {
      this.zincirYukleniyor = true;
      this.CD.detectChanges();
      await this.referansZinciriYukle(ek.bilgiler.kartId);
      this.zincirYukleniyor = false;
      this.CD.detectChanges();
    }
  }

  /** Referans zincirini geriye doğru takip et (max 5 adım) */
  private async referansZinciriYukle(kartId: string, derinlik = 0) {
    if (derinlik >= 5 || !kartId) return;

    try {
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.hareketler.aggregate',
        parametreler: {
          aggregate: [
            { $match: { _id: kartId } },
            {
              $lookup: {
                from: 'hareketler',
                localField: 'veri.icerikler',
                foreignField: '_id',
                as: 'veri.icerikler'
              }
            },
            { $limit: 1 },
          ]
        },
        onEkOlsun: true,
        depoModu: false,
      });
      const cevap: any = await istek.isteSync();
      const kart = cevap?.cevap?.sonuc?.[0];
      if (!kart) return;

      this.referansZinciri.push({
        kartId: kart._id,
        sahip: kart.sahip,
        tarih: kart.tarih,
        sahipIsim: kart.veri?.sahipIsim || 'Kullanıcı',
        sahipResimUrl: this.FikoYT.fapiUrl + '/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.' + kart.sahip + '.resim?boyut=60x?&t=0',
        icerikSayisi: kart.veri?.icerikler?.length || 0,
      });
      this.CD.detectChanges();

      // Eğer bu kartın da EKREFERANS içeriği varsa zinciri takip et
      const ekReferans = kart.veri?.icerikler?.find((i: any) => i?.ek?.turu === 'EKREFERANS');
      if (ekReferans?.ek?.bilgiler?.kartId) {
        await this.referansZinciriYukle(ekReferans.ek.bilgiler.kartId, derinlik + 1);
      }
    } catch (e) {
      console.warn('Referans zinciri yükleme hatası:', e);
    }
  }

  referansDrawerKapat() {
    this.referansDrawerAcik = false;
    this.referansZinciri = [];
    this.CD.detectChanges();
  }
  get miSahip() {
    return this.FikoYT.kimlik.aktifKullaniciJson()._id == this.kart?.sahip;
  }

  /** 3D fotoğraf çekme yetkisi: kart sahibi veya süper yönetici */
  get stpFotoCekebilirMi(): boolean {
    if (this.miSahip) return true;
    const yetkiler = this.FikoYT.kimlik?.aktifKullaniciJson?.()?.yetkiler || [];
    return Array.isArray(yetkiler) && yetkiler.some((x: string) => x === 'Süper Yönetici' || x === 'Super Yonetici');
  }

  /** EKREFERANS gerçek referans mı (başka birinin içeriği) yoksa kendi içeriğimiz mi? */
  get gercekReferansMi(): boolean {
    const ekSahip = this.aktifIcerik?.ek?.bilgiler?.sahip;
    return !!ekSahip && ekSahip !== this.kart?.sahip;
  }

  async ekKonumDuzenle() {
    if (!this.miSahip || !this.aktifIcerik?.ek) return;
    const { HaritaYerSeciciComponent } = await import('@/src/app/uygulamalar/soyagaci/harita-yer-secici/harita-yer-secici.component');
    const sub = this.nzModalServis.create({
      nzTitle: 'Ek Konumu Seç',
      nzContent: HaritaYerSeciciComponent,
      nzWidth: 520,
      nzFooter: null,
      nzData: {
        mevcutYer: this.aktifIcerik.ek.konum?.yerIsmi || '',
        mevcutKoordinat: this.aktifIcerik.ek.konum?.koordinat || null,
      },
    }).afterClose.subscribe((sonuc: any) => {
      if (sonuc?.yerIsmi) {
        if (!this.aktifIcerik.ek.konum) this.aktifIcerik.ek.konum = {};
        this.aktifIcerik.ek.konum.yerIsmi = sonuc.yerIsmi;
        this.aktifIcerik.ek.konum.koordinat = sonuc.koordinat;
        this.icerikGuncelle();
        this.CD.detectChanges();
      }
      sub.unsubscribe();
    });
  }

  async konumIcerikDuzenle() {
    if (!this.miSahip || !this.aktifIcerik?.ek) return;
    const { HaritaYerSeciciComponent } = await import('@/src/app/uygulamalar/soyagaci/harita-yer-secici/harita-yer-secici.component');
    const sub = this.nzModalServis.create({
      nzTitle: 'Konumu Değiştir',
      nzContent: HaritaYerSeciciComponent,
      nzWidth: 520,
      nzFooter: null,
      nzData: {
        mevcutYer: this.aktifIcerik.ek.bilgiler?.yerIsmi || this.aktifIcerik.ek.ismi || '',
        mevcutKoordinat: this.aktifIcerik.ek.bilgiler?.koordinat || null,
      },
    }).afterClose.subscribe((sonuc: any) => {
      if (sonuc?.yerIsmi) {
        this.aktifIcerik.ek.ismi = sonuc.yerIsmi;
        this.aktifIcerik.ek.bilgiler = { yerIsmi: sonuc.yerIsmi, koordinat: sonuc.koordinat };
        this.icerikGuncelle();
        if (this.konumLeafletMap) { this.konumLeafletMap.remove(); this.konumLeafletMap = null; }
        this.konumHaritaAktifId = null;
        this.CD.detectChanges();
      }
      sub.unsubscribe();
    });
  }

  async icerikGuncelle() {
    this.FikoYT.degisti.emit();

    const icerik = this.aktifIcerik;
    if (!icerik?._id) return;

    try {
      const guncelleme: any = {
        _id: icerik._id,
        'ek.konum': icerik.ek?.konum ?? null,
      };
      // KONUM tipi ek ise bilgiler ve ismi de güncelle
      if (icerik.ek?.turu === 'KONUM') {
        guncelleme['ek.bilgiler'] = icerik.ek.bilgiler;
        guncelleme['ek.ismi'] = icerik.ek.ismi;
      }

      const formData = new FormData();
      formData.append('req_body', JSON.stringify(guncelleme));

      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });
    } catch (e) {
      console.error('İçerik konum güncellenemedi:', e);
    }
  }

  constructor(public readonly FikoYT: FikoYTService, public readonly CD: ChangeDetectorRef, @Inject(DOCUMENT) private readonly document: Document, public router: Router, private nzMessage: NzMessageService, private nzModalServis: NzModalService, private soyAgaci: SoyAgaciService) {
    // CD.detach();
    this.subsList.push(FikoYT.degisti.subscribe(() => {
      CD.detectChanges();
      $('.ui.embed').embed({
        brandedUI: true,
      });
    }))
  }



  ngOnInit(): void {
    $('.ui.embed').embed({
      brandedUI: true
    });
  }

  ngAfterViewInit(): void {
    // Lightbox'ı body'e taşı (parent transform'lar position:fixed'ı bozuyor)
    if (this.lightboxOverlay?.nativeElement) {
      this.document.body.appendChild(this.lightboxOverlay.nativeElement);
    }
    // STP-3D tanı: sayfa yenilendikten sonra resimid'in hydrated veride gelip gelmediğini gösterir
    [1000, 3500].forEach(ms => setTimeout(() => {
      const ek = this.aktifIcerik?.ek;
      if (ek && (ek.ismi?.endsWith('.stp') || ek.ismi?.endsWith('.wrl') || ek.ismi?.endsWith('.FikoWrl'))) {
        console.log(`[STP-3D][${ms}ms] icerik._id=${this.aktifIcerik?._id} ek._id=${ek._id} ek.resimid=${ek.resimid ?? 'YOK'}`);
      }
    }, ms));
  }

  ngAfterViewChecked(): void {
    // 🚀 PERF: konumHaritaGuncelle async'tir; her CD'de çağrısı gereksiz bir
    // Promise/microtask üretiyordu. Sadece gerçekten bir konum içeriği
    // görünürken çağır (çoğu içerik KONUM değil). Idempotent guard hâlâ içeride.
    const ek = this.aktifIcerik?.ek;
    if (ek?.turu !== 'KONUM' || !ek?.bilgiler?.koordinat || !this.konumHaritaDiv?.nativeElement) return;
    this.konumHaritaGuncelle();
  }

  private async konumHaritaGuncelle() {
    const ek = this.aktifIcerik?.ek;
    if (ek?.turu !== 'KONUM' || !ek?.bilgiler?.koordinat || !this.konumHaritaDiv?.nativeElement) {
      return;
    }
    const ekId = ek._id || `${ek.bilgiler.koordinat.lat}_${ek.bilgiler.koordinat.lng}`;
    if (this.konumHaritaAktifId === ekId) return;
    this.konumHaritaAktifId = ekId;

    if (this.konumLeafletMap) {
      this.konumLeafletMap.remove();
      this.konumLeafletMap = null;
    }

    const L = await import('leaflet').then(m => (m as any).default ?? m);
    const lat = ek.bilgiler.koordinat.lat;
    const lng = ek.bilgiler.koordinat.lng;
    const map = L.map(this.konumHaritaDiv.nativeElement, { zoomControl: false, attributionControl: false }).setView([lat, lng], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
    const pinIcon = L.divIcon({
      className: '',
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
        <defs><filter id="s" x="-20%" y="-10%" width="140%" height="130%"><feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity="0.3"/></filter></defs>
        <path d="M16 0C7.16 0 0 7.16 0 16c0 12 16 26 16 26s16-14 16-26C32 7.16 24.84 0 16 0z" fill="#e74c3c" filter="url(#s)"/>
        <circle cx="16" cy="16" r="7" fill="white"/>
        <circle cx="16" cy="16" r="4" fill="#e74c3c"/>
      </svg>`,
      iconSize: [32, 42],
      iconAnchor: [16, 42],
    });
    L.marker([lat, lng], { icon: pinIcon }).addTo(map);
    this.konumLeafletMap = map;
    setTimeout(() => map.invalidateSize(), 200);
  }

  tiklandiEkSil($event: any) {

  }

  tiklandiIcerikTamEkran(elem: any) {
    const ek = this.icerikler[this.aktifIcerikNo]?.ek;
    if (!ek) return;
    if (ek.turu == IEkTuru.RESIM) {
      this.lightboxAc();
    } else if (ek.turu == IEkTuru.FIKOGL) {
      window.open(this.FikoYT.fapiUrl + '/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.' + ek.resimid + '.dosyaResim', '_blank');
    }
  }

  // ─── Lightbox Sistemi ──────────────────────────────────────────
  lightboxAcik = false;
  lightboxZoom = 1;
  lightboxPanX = 0;
  lightboxPanY = 0;
  lightboxResimAlani: { left: number; top: number; width: number; height: number } | null = null;
  private _lbPanAktif = false;
  private _lbPanStartX = 0;
  private _lbPanStartY = 0;
  private _lbPanOffsetX = 0;
  private _lbPanOffsetY = 0;
  private _lbKeydownHandler: ((e: KeyboardEvent) => void) | null = null;

  lightboxAc() {
    this.lightboxAcik = true;
    this.lightboxZoom = 1;
    this.lightboxPanX = 0;
    this.lightboxPanY = 0;
    this.lightboxResimAlani = null;
    this.document.body.style.overflow = 'hidden';
    this.document.body.classList.add('fikoyt-lightbox-aktif');
    // Keyboard listener
    this._lbKeydownHandler = (e: KeyboardEvent) => this.lightboxKeydown(e);
    this.document.addEventListener('keydown', this._lbKeydownHandler);
    this.CD.detectChanges();
    // display:none→flex geçişinde resim zaten yüklüyse alan hesapla
    this._lightboxResimAlaniHesapla();
  }

  /** Lightbox resim alanını hesapla (double-RAF ile layout'un tamamlanmasını garantile) */
  private _lightboxResimAlaniHesapla() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const img = this.lightboxOverlay?.nativeElement?.querySelector('.lightbox-resim') as HTMLImageElement;
        if (img?.complete && img.naturalWidth > 0) {
          this.lightboxResimYuklendi({ target: img } as any);
        }
      });
    });
  }

  lightboxKapat() {
    this.lightboxAcik = false;
    this.document.body.style.overflow = '';
    this.document.body.classList.remove('fikoyt-lightbox-aktif');
    if (this._lbKeydownHandler) {
      this.document.removeEventListener('keydown', this._lbKeydownHandler);
      this._lbKeydownHandler = null;
    }
    this.CD.detectChanges();
  }

  lightboxKeydown(e: KeyboardEvent) {
    if (!this.lightboxAcik) return;
    switch (e.key) {
      case 'Escape': this.lightboxKapat(); break;
      case '+': case '=': this.lightboxZoomDegistir(0.25); break;
      case '-': this.lightboxZoomDegistir(-0.25); break;
      case '0': this.lightboxSifirla(); break;
      case 'ArrowLeft': if (this.aktifIcerikNo > 0) { this.aktifIcerikNo--; this.lightboxSifirla(); } break;
      case 'ArrowRight': if (this.aktifIcerikNo < this.icerikler.length - 1) { this.aktifIcerikNo++; this.lightboxSifirla(); } break;
      case 'f': case 'F': if (this.miSahip) { this.yuzEtiketModuAktif = !this.yuzEtiketModuAktif; this.bekleyenEtiket = null; this.CD.detectChanges(); } break;
    }
  }

  lightboxZoomDegistir(delta: number) {
    this.lightboxZoom = Math.max(0.25, Math.min(8, this.lightboxZoom + delta));
    if (Math.abs(this.lightboxZoom - 1) < 0.05) this.lightboxZoom = 1;
    this.CD.detectChanges();
  }

  lightboxSifirla() {
    this.lightboxZoom = 1;
    this.lightboxPanX = 0;
    this.lightboxPanY = 0;
    this.lightboxResimAlani = null;
    this.CD.detectChanges();
    this._lightboxResimAlaniHesapla();
  }

  lightboxWheel(e: WheelEvent) {
    e.preventDefault();
    e.stopPropagation();
    const delta = e.deltaY < 0 ? 0.15 : -0.15;
    this.lightboxZoomDegistir(delta);
  }

  lightboxCiftTiklandi(e: MouseEvent) {
    e.stopPropagation();
    if (this.yuzEtiketModuAktif) return;
    if (this.lightboxZoom > 1) {
      this.lightboxSifirla();
    } else {
      this.lightboxZoom = 2.5;
      this.CD.detectChanges();
    }
  }

  lightboxPanBasla(e: MouseEvent) {
    if (this.lightboxZoom <= 1 || this.yuzEtiketModuAktif) return;
    e.preventDefault();
    this._lbPanAktif = true;
    this._lbPanStartX = e.clientX;
    this._lbPanStartY = e.clientY;
    this._lbPanOffsetX = this.lightboxPanX;
    this._lbPanOffsetY = this.lightboxPanY;
    const hareket = (ev: MouseEvent) => {
      if (!this._lbPanAktif) return;
      this.lightboxPanX = this._lbPanOffsetX + (ev.clientX - this._lbPanStartX) / this.lightboxZoom;
      this.lightboxPanY = this._lbPanOffsetY + (ev.clientY - this._lbPanStartY) / this.lightboxZoom;
      this.CD.detectChanges();
    };
    const birak = () => {
      this._lbPanAktif = false;
      this.document.removeEventListener('mousemove', hareket);
      this.document.removeEventListener('mouseup', birak);
    };
    this.document.addEventListener('mousemove', hareket);
    this.document.addEventListener('mouseup', birak);
  }

  lightboxResimYuklendi(e: Event) {
    const img = e.target as HTMLImageElement;
    const container = img.closest('.lightbox-resim-konteynir');
    if (!container) return;
    const cRect = container.getBoundingClientRect();
    // Lightbox'ta img zaten max-width/max-height + flexbox ile doğru konumda
    // resimGercekBounds yerine direkt img rect kullan (daha doğru)
    const imgRect = img.getBoundingClientRect();
    this.lightboxResimAlani = {
      left: ((imgRect.left - cRect.left) / cRect.width) * 100,
      top: ((imgRect.top - cRect.top) / cRect.height) * 100,
      width: (imgRect.width / cRect.width) * 100,
      height: (imgRect.height / cRect.height) * 100,
    };
    this.CD.detectChanges();
  }

  lightboxResimEtiketle(e: MouseEvent) {
    if (!this.yuzEtiketModuAktif || !this.miSahip || !this.lightboxResimAlani) return;
    const target = e.target as HTMLElement;
    const katman = target.closest('.lightbox-etiket-katman');
    if (!katman) return;
    const r = katman.getBoundingClientRect();
    const xPct = ((e.clientX - r.left) / r.width) * 100;
    const yPct = ((e.clientY - r.top) / r.height) * 100;
    const w = 10, h = 12;
    this.bekleyenEtiket = {
      x: Math.max(0, Math.min(100 - w, xPct - w / 2)),
      y: Math.max(0, Math.min(100 - h, yPct - h / 2)),
      w, h,
    };
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  get lightboxResimUrl(): string {
    const ek = this.aktifIcerik?.ek;
    if (!ek?._id) return '';
    // 3D (STP/WRL) içerikte çekilen görüntü (resimid) varsa onu göster
    const stpMi = ek.ismi?.endsWith('.stp') || ek.ismi?.endsWith('.wrl') || ek.ismi?.endsWith('.FikoWrl');
    const id = stpMi && ek.resimid ? ek.resimid : ek._id;
    return this.FikoYT.fapiUrl + '/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.' + id + '.resim';
  }

  /** STP görüntü önizlemesine tıklanınca lightbox açar */
  tryLbAcStp() {
    if (this.stpGoruntuUrl) this.lightboxAc();
  }

  lightboxIndir() {
    const url = this.lightboxResimUrl;
    if (!url) return;
    window.open(url, '_blank');
  }

  /** Lightbox'ta sayfa navigasyonu: sonraki resim sayfasına git */
  lightboxSonrakiResim(yon: number) {
    const yeniNo = this.aktifIcerikNo + yon;
    if (yeniNo >= 0 && yeniNo < this.icerikler.length) {
      this.aktifIcerikNo = yeniNo;
      this.lightboxSifirla();
    }
  }

  tiklandiFikoGL(icerik: any) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['🧩', '💎'])
    );

    const wnd = window.open(url, '_blank');
    //@ts-ignore
    wnd.dosyaTuru = icerik?.ek?.turu;
    //@ts-ignore
    wnd.dosya = this.FikoYT.fapiUrl + '/fikoyt.com.FikoYT.sistem.aktifKullanici.hareketler.' + icerik?.ek?.id + '.dosya';
    // //@ts-ignore
    // console.log(wnd.dosya, wnd.dosyaTuru)
  }

  /** Template'de her CD cycle'da cagrilir, basit cache ile gereksiz hesaplamayi onler */
  private _okunabilirBoyutCache = new Map<number, string>();
  okunabilirBoyut(bytes: any) {
    if (bytes == null || isNaN(bytes) || bytes <= 0) return '0 B';
    const cached = this._okunabilirBoyutCache.get(bytes);
    if (cached) return cached;
    var i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    //@ts-ignore
    const sonuc = (bytes / Math.pow(1024, i)).toFixed(3) * 1 + ' ' + sizes[i];
    this._okunabilirBoyutCache.set(bytes, sonuc);
    return sonuc;
  }

  /** AYRAÇ: */

  clickCount = 0;
  get editMode(): boolean { return this._editMode || this.duzenlemeModunda; }
  set editMode(v: boolean) { this._editMode = v; }
  private _editMode = false;
  ciftTiklandiAciklama() {
    this.clickCount++;
    setTimeout(() => {
      if (this.clickCount >= 2) {
        const aktifKullanici = this.FikoYT.kimlik.aktifKullaniciJson();
        if (aktifKullanici?._id == this.kart?.sahip || aktifKullanici?._id == this.kart?.veri?.sahip) {
          this.duzenlemeBaslatildi.emit();
        }
      }
      this.clickCount = 0;
    }, 300)
  }


  /** Çekilen 3D görüntüyü kalıcı yapar: resimid üretir, içerik belgesine yazar, kart dokümanını id-listesi formatında tutar */
  async fotografYuklendiHandler(blob: Blob) {
    const icerik = this.aktifIcerik;
    const ek = icerik?.ek;
    const kartId = this.kart?._id;
    if (!ek || !kartId || !icerik?._id || !(blob instanceof Blob)) return;

    // İstemci tarafında dosya id'si (resimid) üretilir; multipart alan adı da bu id olur → GridFS dosya id'si = resimid
    const resimid = this.FikoYT.fikoIdUret();
    ek.resimid = resimid;
    this.CD.detectChanges();

    try {
      // 1) İçerik belgesini resimid'li haliyle yaz + dosyayı multipart yükle (alan adı = resimid → GridFS id = resimid)
      //    ekDosyaSecildi/ikart akışıyla aynı desen: ekle isteği _id ile upsert yapar (yoksa oluşturur, varsa günceller)
      const belge = JSON.parse(JSON.stringify(icerik));
      belge._uid = kartId;
      belge.ek = belge.ek || {};
      belge.ek.resimid = resimid;
      // Serileştirilemez/yerel alanları temizle
      delete belge.ek?.dosyaObjectUrl;
      delete belge.ek?.objectUrl;
      delete belge.ek?.resimObjectUrl;
      delete belge.ek?.dosya;
      const belgeForm = new FormData();
      belgeForm.append('req_body', JSON.stringify(belge));
      belgeForm.append(resimid, blob, 'stp-goruntu.png');
      const ekleCevap: any = await this.ekleIstegi(belgeForm);
      console.log('[STP-3D] ekle yanıtı:', JSON.stringify(ekleCevap)?.substring(0, 500));
      if (!ekleCevap?.cevap) throw new Error('İçerik belgesi kaydedilemedi');

      // 2) Kart dokümanını id-listesi formatına normalize et
      //    (veri.icerikler DB'de id dizisidir, okurken $lookup ile doldurulur — tam obje yazmak akışı bozar)
      const idList = this.icerikler.map(c => c?._id).filter(Boolean);
      const kartForm = new FormData();
      kartForm.append('req_body', JSON.stringify({
        filter: { _id: kartId },
        set: {
          'veri.icerikler': idList,
          icerikler: idList,
          duzenlenmeTarihi: new Date(),
        },
      }));
      await this.guncelleIstegi(kartForm);

      // this.nzMessage.success('3D görüntü kaydedildi');
    } catch (err) {
      console.warn('3D görüntü kayıt hatası:', err);
      delete ek.resimid;
      this.nzMessage.error('Görüntü kaydedilemedi');
    }
    this.CD.detectChanges();
  }

  /** DB.hareketler.guncelle — multipart destekli, uygulamanın kanonik istek yolu */
  private guncelleIstegi(formData: FormData): Promise<any> {
    return new FikoYTIstekKok({
      metod: 'POST',
      komut: 'FikoYT.sistem.DB.hareketler.guncelle',
      onEkOlsun: true,
      parametreler: formData,
      depoModu: false,
      gecikmeliCevap: false,
    }).isteSync();
  }

  /** DB.hareketler.ekle — multipart destekli */
  private ekleIstegi(formData: FormData): Promise<any> {
    return new FikoYTIstekKok({
      metod: 'POST',
      komut: 'FikoYT.sistem.DB.hareketler.ekle',
      onEkOlsun: true,
      parametreler: formData,
      depoModu: false,
      gecikmeliCevap: false,
    }).isteSync();
  }

  /** Aktif içeriğin 3D görüntü önizleme URL'si (çekilen görüntü kalıcı ise) */
  get stpGoruntuUrl(): string {
    const ek = this.aktifIcerik?.ek;
    if (!ek?.resimid) return '';
    return `${this.FikoYT.fapiUrl}/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.${ek.resimid}.resim?boyut=400x?&t=${Date.now()}`;
  }

  async sayfaEkle() {
    if (!this.icerikler || !this.miSahip) return;
    const yeniIcerik: IIcerik = { _id: this.FikoYT.fikoIdUret(), aciklama: '', html: '', ek: null, sifre: null };
    this.icerikler.push(yeniIcerik);
    this.aktifIcerikNo = this.icerikler.length - 1;
    this.CD.detectChanges();
    await this.kartIcerikleriKaydet();
    // this.nzMessage.success('Yeni sayfa eklendi');
  }

  async sayfaSil() {
    if (!this.icerikler || this.icerikler.length <= 1 || !this.miSahip) return;
    this.icerikler.splice(this.aktifIcerikNo, 1);
    if (this.aktifIcerikNo >= this.icerikler.length) {
      this.aktifIcerikNo = this.icerikler.length - 1;
    }
    this.CD.detectChanges();
    await this.kartIcerikleriKaydet();
    // this.nzMessage.success('Sayfa silindi');
  }

  /** Kart'ın veri.icerikler dizisini DB'ye kaydeder (içerikler ayrı belge + karta id listesi) */
  private async kartIcerikleriKaydet() {
    const kartId = this.kart?._id;
    if (!kartId) return;
    try {
      // 1) Her içeriği kendi belgesine upsert et
      for (const ic of (this.icerikler || [])) {
        if (!ic?._id) continue;
        const belge = JSON.parse(JSON.stringify(ic));
        belge._uid = kartId;
        delete belge.ek?.dosyaObjectUrl;
        delete belge.ek?.objectUrl;
        delete belge.ek?.resimObjectUrl;
        delete belge.ek?.dosya;
        delete belge.ek?._sablonDosyalar;
        const fd = new FormData();
        fd.append('req_body', JSON.stringify(belge));
        await new FikoYTIstekKok({
          metod: 'POST',
          komut: 'FikoYT.sistem.DB.hareketler.ekle',
          onEkOlsun: true,
          parametreler: fd,
          depoModu: false,
          gecikmeliCevap: false,
        }).isteSync();
      }
      // 2) Kart dokümanına id listesi yaz ($lookup hydration formatı)
      const idList = (this.icerikler || []).map((c: any) => c?._id).filter(Boolean);
      const guncelleme = {
        filter: { _id: kartId },
        set: {
          'veri.icerikler': idList,
          icerikler: idList,
          duzenlenmeTarihi: new Date(),
        },
      };
      const formData = new FormData();
      formData.append('req_body', JSON.stringify(guncelleme));
      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.guncelle`, {
        method: 'POST',
        body: formData,
      });
    } catch (e) {
      console.error('Kart icerikler kayıt hatası:', e);
      this.nzMessage.error('Kayıt başarısız');
    }
  }

  /** Düzenleme modunda dosya eki seçildiğinde: dosyayı sunucuya yükler ve icerik.ek günceller */
  async ekDosyaSecildi($event: any) {
    if (!$event.target.files?.length || !this.miSahip) return;
    const dosya: File = $event.target.files[0];
    const icerik = this.icerikler?.[this.aktifIcerikNo];
    if (!icerik) return;

    // Dosya türünü belirle
    let turu: string;
    if (dosya.type.startsWith('image')) turu = 'RESIM';
    else if (dosya.type.startsWith('video')) turu = 'VIDEO';
    else if (dosya.type.startsWith('audio')) turu = 'SES';
    else turu = 'DOSYA';

    // Ek objesi oluştur
    const ekId = this.FikoYT.fikoIdUret();
    icerik.ek = {
      _id: ekId,
      turu: turu as any,
      boyut: dosya.size,
      ismi: dosya.name,
      tipi: dosya.type,
    } as any;
    this.CD.detectChanges();

    try {
      // Önce kart iceriklerini kaydet (ek metadata'sı ile birlikte)
      await this.kartIcerikleriKaydet();

      // Sonra dosyayı yükle
      const formData = new FormData();
      formData.append('req_body', JSON.stringify(icerik));
      formData.append(ekId, dosya, dosya.name);

      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      const response = await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        // this.nzMessage.success('Dosya eklendi');
      } else {
        throw new Error('Dosya yükleme başarısız');
      }
    } catch (e) {
      console.error('Dosya ek yükleme hatası:', e);
      this.nzMessage.error('Dosya yüklenemedi');
      icerik.ek = null;
    }
    this.CD.detectChanges();
  }

  async kaydetTiklandi($event: any) {
    this.editMode = false;
    this.CD.detectChanges();

    const icerik = this.icerikler[this.aktifIcerikNo];
    if (!icerik?._id) {
      this.nzMessage.error('İçerik bulunamadı');
      return;
    }

    try {
      // NOT: hareketler.ekle bir upsert komutudur ve gönderilen req_body'yi belgenin
      // TAMAMI olarak işler. Sadece {_id, html} göndermek `ek` alanının (turu, dosya,
      // resimid — 3D/STP-WRL tanımının dayandığı her şey) sunucuda SİLİNMESİNE yol açar.
      // Bu yüzden mevcut içerik belgesinin tamamını (serileştirilemez alanlar temizlenmiş
      // haliyle) gönderiyoruz — sadece html alanını güncelliyoruz.
      const belge: any = JSON.parse(JSON.stringify(icerik));
      belge.html = $event;
      if (belge.ek) {
        delete belge.ek.dosyaObjectUrl;
        delete belge.ek.objectUrl;
        delete belge.ek.resimObjectUrl;
        // Gerçek File/Blob değilse (JSON roundtrip'ten kalan {} sızıntısı) temizle
        if (belge.ek.dosya && typeof belge.ek.dosya === 'object' && !belge.ek.dosya.rid && !belge.ek.dosya._id) delete belge.ek.dosya;
        if (belge.ek.resim && typeof belge.ek.resim === 'object' && !belge.ek.resim.rid && !belge.ek.resim._id) delete belge.ek.resim;
      }

      const formData = new FormData();
      formData.append('req_body', JSON.stringify(belge));

      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      const response = await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        // this.nzMessage.success('Açıklama kaydedildi');
      } else {
        throw new Error('Kaydetme başarısız');
      }
    } catch (e) {
      console.warn('Açıklama MongoDB kayıt hatası:', e);
      this.nzMessage.error('Kayıt yapılamadı');
    }
    this.CD.detectChanges();
  }

  tiklandiSifreKaldir($event: any) {
    // this.editMode = false;
    this.CD.detectChanges();

    // const formData: FormData = new FormData();
    // formData.append('req_body', JSON.stringify({ sifre: null }));


    // const subsDegistir = (this.FikoYT.istekler.fapisteV1<any>(
    //   "POST",
    //   `FikoYT.sistem.hareketler.icerik.${this.aktifIcerik._id}.sifre.degistir`,
    //   null, formData)
    //   // .pipe(filter((value: any) => value.turu === IstekOlayTuru.Cevaplandi), map((value: any) => value.sonuc.body))
    //   .subscribe(
    //     (snc: any) => {
    //       if (snc.turu === IstekOlayTuru.Cevaplandi) {
    //         this.girilenSifre = null
    //         console.log(snc)
    //       }
    //     },
    //     (hata: any) => {

    //     },
    //     () => {
    //       subsDegistir.unsubscribe();
    //     }
    //   )
    // );
  }

  tiklandiSifreDegistir($event: any = null) {
    // this.editMode = false;
    this.CD.detectChanges();

    // const formData: FormData = new FormData();
    // formData.append('req_body', JSON.stringify({ sifre: $event }));


    // const subsDegistir = (this.FikoYT.istekler.fapisteV1<any>(
    //   "POST",
    //   `FikoYT.sistem.hareketler.icerik.${this.aktifIcerik._id}.sifre.degistir`,
    //   null, formData)
    //   // .pipe(filter((value: any) => value.turu === IstekOlayTuru.Cevaplandi), map((value: any) => value.sonuc.body))
    //   .subscribe(
    //     (snc: any) => {
    //       if (snc.turu === IstekOlayTuru.Cevaplandi) {
    //         this.girilenSifre = null
    //         console.log(snc)
    //       }
    //     },
    //     (hata: any) => {

    //     },
    //     () => {
    //       subsDegistir.unsubscribe();
    //     }
    //   )
    // );
  }
  parametreProxy(parametreler: any[]): any {
    return new Proxy({}, {
      get(_, prop: string) {
        return parametreler.find(p => p.ismi === prop)?.degeri ?? null;
      },
      set(_, prop: string, value) {
        const param = parametreler.find(p => p.ismi === prop);
        if (param) {
          param.degeri = value;
          return true;
        }
        return false; // yoksa hiçbir şey yapma
      }
    });
  }
  // Ses oynatıcıdan transkript geldiğinde MongoDB'ye kaydet
  async transkriptHazirEvent(veri: { metin: string; segmentler: { start: number; end: number; text: string }[] }) {
    const icerik = this.aktifIcerik;
    if (!icerik?.ek || !veri?.metin || !icerik._id) return;

    icerik.ek.transkript = veri.metin;
    icerik.ek.transkriptSegmentleri = veri.segmentler || [];

    try {
      const guncelleme: any = {
        _id: icerik._id,
        'ek.transkript': veri.metin,
        'ek.transkriptSegmentleri': veri.segmentler || []
      };

      const formData = new FormData();
      formData.append('req_body', JSON.stringify(guncelleme));

      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });
      // this.nzMessage.success('Transkript kaydedildi');
    } catch (e) {
      console.warn('Transkript MongoDB kayıt hatası:', e);
    }
    this.CD.detectChanges();
  }

  /** AYRAÇ: */

  ngOnDestroy(): void {
    this.subsList.forEach(element => {
      element.unsubscribe();
    });
    this._isleniyorSub?.unsubscribe();
    if (this.konumLeafletMap) {
      this.konumLeafletMap.remove();
      this.konumLeafletMap = null;
    }
    if (this.resimAlaniObserver) {
      this.resimAlaniObserver.disconnect();
      this.resimAlaniObserver = null;
    }
    // Timer'lari temizle (memory leak onleme)
    if (this.tapPeekTimer) {
      clearTimeout(this.tapPeekTimer);
      this.tapPeekTimer = null;
    }
    if (this.yuzEtiketAramaTimer) {
      clearTimeout(this.yuzEtiketAramaTimer);
      this.yuzEtiketAramaTimer = null;
    }
    if (this.otomatikYuzAramaTimer) {
      clearTimeout(this.otomatikYuzAramaTimer);
      this.otomatikYuzAramaTimer = null;
    }
    // Lightbox temizliği
    if (this._lbKeydownHandler) {
      this.document.removeEventListener('keydown', this._lbKeydownHandler);
      this._lbKeydownHandler = null;
    }
    if (this.lightboxAcik) {
      this.document.body.style.overflow = '';
      this.document.body.classList.remove('fikoyt-lightbox-aktif');
    }
    // Lightbox DOM elemanını body'den kaldır
    if (this.lightboxOverlay?.nativeElement?.parentNode === this.document.body) {
      this.document.body.removeChild(this.lightboxOverlay.nativeElement);
    }
    // Uygulama parametre kaydet timer'ini temizle (memory leak onleme)
    if (this._uygulamaParamKaydetTimer) {
      clearTimeout(this._uygulamaParamKaydetTimer);
      this._uygulamaParamKaydetTimer = null;
    }
  }
}
